export const whenToSendImageOptions = [
  { id: '1', name: 'Antes da mensagem' },
  { id: '2', name: 'Depois da mensagem' },
  { id: '3', name: 'Junto da mensagem' }
];
